import React, { useContext } from 'react'
import styled from 'styled-components'
import cookie from 'react-cookies'
import { useStripe, useElements } from '@stripe/react-stripe-js'
import { ReactSVG } from 'react-svg'
import ReactTooltip from 'react-tooltip'
import { usePromiseTracker } from 'react-promise-tracker'
import { useHistory } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import AppContext from '../../context/appContext'
import MobileSubscriptionImage from '../../assets/REDESIGN_Assets/SelectSubscriptionScreen/select-sub-image.png'

import FitmatkaImage from '../../assets/REDESIGN_Assets/Diet/fitmatka-image.webp'

import Loader from '../Loader/Loader.tsx'
import topBar from '../../assets/choseSubscriptionPlan/top_bar.png'
import exclaimation from '../../assets/SelectSubscriptionScreen/exclaimationMarkIcon.svg'
import americanExpressIcon from '../../assets/choseSubscriptionPlan/americanExpressIcon4.png'
import googlePayIcon from '../../assets/choseSubscriptionPlan/googlePayIcon2.png'
import masterCardIcon from '../../assets/choseSubscriptionPlan/masterCardIcon2.png'
import przelewy24Icon from '../../assets/choseSubscriptionPlan/przelewy24Icon.png'
import visaIcon from '../../assets/choseSubscriptionPlan/visaIcon2.png'
import { mediaQ, fontSizeResponsive } from '../theme/mixins'

import {
  CheckboxContainer,
  CustomCheckedIcon,
  CustomUncheckedIcon,
} from '../AddUserScreen/AddUser.jsx'
import Checkbox from '@material-ui/core/Checkbox'

import { openStripePortalSession } from '../../Api/backendApi'

// Redesign imports
import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'

import {
  SelectSubBox,
  TwineBallAnnotation,
  SubPlanScreenCard,
  PackageButton,
  DemoModeBox,
} from './style/SelectSubscriptionPlanScreenStyle'
import GenericColumn from '../../GenericComponents/GenericColumn'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'
import GenericRow from '../../GenericComponents/GenericRow'
import GenericCheckbox from '../../GenericComponents/GenericCheckbox'
import GenericIcon from '../../GenericComponents/GenericIcon'
import GenericLogo from '../../GenericComponents/GenericLogo'

import ExclaimIcon from '../../assets/REDESIGN_Assets/SelectSubscriptionScreen/exclaimation-mark.svg'
import VisaIcon from '../../assets/REDESIGN_Assets/SelectSubscriptionScreen/visa-icon.svg'
import AmericaExpressIcon from '../../assets/REDESIGN_Assets/SelectSubscriptionScreen/america-express-icon.svg'
import Mastercardicon from '../../assets/REDESIGN_Assets/SelectSubscriptionScreen/mastercard-icon.svg'
import WomanIcon from '../../assets/REDESIGN_Assets/SelectSubscriptionScreen/woman-icon.png'

import { MainScreenPromoBanner } from '../MainScreen/styles/MainScreenStyles'

import GenericButton from '../../GenericComponents/GenericButton'

export const TopColorBar = styled.div`
  position: ${(props) => (props.relative ? 'relative' : 'absolute')};
  z-index: ${(props) => (props.zIndex ? props.zIndex : 'unset')};
  top: 0;
  left: 0;
  width: 100%;
  height: ${(props) => (props.topColorBar ? props.topColorBar : '5.2vh')};
  background: url('${topBar}');
  background-size: contain;
  display: ${(props) => (props.subinfo ? 'flex' : 'block')};
  justify-content: ${(props) => (props.subinfo ? 'flex-end' : 'unset')};
  align-items: ${(props) => (props.subinfo ? 'center' : 'unset')};

  ${mediaQ('desktopAll', 'background-size: cover;')}

  &.mainScreen {
    ${mediaQ('mobileAll', 'height: 5.2vh; position:fixed;top:0; width: 100%;')}
  }
`
export const SvgElement = styled(ReactSVG)`
  fill: ${(props) => (props.fill ? props.fill : 'white !important')};
  width: ${(props) => (props.width ? `${props.width} !important` : '20px')};
  height: ${(props) => (props.height ? `${props.height} !important` : '20px')};
  transform: ${(props) =>
    props.scale ? `scale(${props.scale}) !important` : 'scale(0.7)'};
  margin-right: 15px;
  margin-bottom: 5px;
`
const SelectSubscriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: #212121;

  ${mediaQ(
    'desktopAll',
    'flex-wrap: wrap; flex-direction: row; max-height: 100vh;'
  )}
`
const TextRow = styled.span`
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : 'inherit')};
  display: flex;
  justify-content: ${(props) => (props.justify ? props.justify : 'unset')};
  width: 100%;
  ${(props) =>
    props.fontSize
      ? fontSizeResponsive(props.fontSize)
      : fontSizeResponsive(19)};
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'unset')};
  margin-top: ${(props) => (props.mt ? `${props.mt}px` : 'unset')};
  margin-bottom: ${(props) => (props.mb ? `${props.mb}px` : 'unset')};
  color: ${(props) => (props.color ? props.color : 'inherit')};
  font-weight: 500;
`
export const TextColumn = styled.span`
  font-family: ${(props) => (props.fontFamily ? props.fontFamily : 'inherit')};
  display: inline-block;
  color: ${(props) => (props.color ? props.color : 'inherit')};
  ${(props) => (props.fSize ? `${fontSizeResponsive(props.fSize)}` : null)};
  text-transform: ${(props) => (props.uppercase ? 'uppercase' : 'unset')};
  font-weight: ${(props) => (props.fw ? props.fw : 'unset')};
`
const TextBold = styled.span`
  display: contents;
  font-weight: bold;
  font-size: ${(props) => (props.bigger ? props.bigger : 'inherit')};
`
const UnskewWrapper = styled.div`
  transform: skew(1.5deg, 1.5deg);
`

const SelectSubscriptionHeader = styled.header`
  max-width: 80%;
  margin-left: 10%;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaQ(
    'desktopAll',
    'position: absolute; max-width:40%; margin-left: 5%; top: 40%'
  )}
  ${mediaQ('mobileAll', 'margin-top:8vh;')}


${(props) =>
    props.paidContentMode
      ? `${mediaQ('mobileAll', 'margin-top:10vh;')}`
      : props.hasSub
      ? `${mediaQ('mobileAll', 'margin-top:8vh;')}`
      : `${mediaQ('mobileAll', 'margin-top:24vh;')}`};
`

const HeaderText = styled.h2`
  font-family: 'Asap Condensed';
  font-weight: bold;
  margin-top: 15px;
  ${fontSizeResponsive(55)};
  text-align: center;
  text-transform: uppercase;
`

const SelectSubscriptionSection = styled.section`
  padding: ${(props) => (props.padding ? props.padding : 'unset')};

  ${mediaQ(
    'desktopAll',
    'display: flex; flex-direction: column; flex-wrap: wrap; width: 99%; align-items: flex-end; margin-right: 10%; justify-content: center;height: 96vh'
  )}
`
const SelectSubscriptionCard = styled.button`
  background: rgb(254, 13, 160);
  background: linear-gradient(
    0deg,
    rgba(254, 13, 160, 1) 0%,
    rgba(250, 174, 1, 1) 100%
  );
  border: none;
  outline: none;
  border-radius: 5px;
  margin-top: 25px;
  transform: skew(-1.5deg, -1.5deg);
  width: 95%;
  margin-left: 2.5%;
  padding: 10px 25px;
  box-shadow: 0 2.8px 3.2px -26px rgba(0, 0, 0, 0.037),
    0 6.7px 7.6px -26px rgba(0, 0, 0, 0.053),
    0 12.5px 14.4px -26px rgba(0, 0, 0, 0.065),
    0 22.3px 25.7px -26px rgba(0, 0, 0, 0.077),
    0 41.8px 48px -26px rgba(0, 0, 0, 0.093),
    0 100px 115px -26px rgba(0, 0, 0, 0.13);
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.05) skew(-1.5deg, -1.5deg) translateY(-10px);
    box-shadow: 0 2.8px 5.7px -68px rgba(0, 0, 0, 0.112),
      0 6.7px 13.6px -68px rgba(0, 0, 0, 0.162),
      0 12.5px 25.7px -68px rgba(0, 0, 0, 0.2),
      0 22.3px 45.8px -68px rgba(0, 0, 0, 0.238),
      0 41.8px 85.6px -68px rgba(0, 0, 0, 0.288),
      0 100px 205px -68px rgba(0, 0, 0, 0.4);
  }

  ${mediaQ(
    'desktopAll',
    'max-width: 40%; margin-top: 45px; padding: 3vw 45px;'
  )}
`
const InformationSection = styled.section`
  margin: 15px 5% 0px 5%;
  ${mediaQ(
    'desktopAll',
    'position: absolute; max-width:40%; margin-left: 5%; bottom: 30%; padding: unset;'
  )}
`
const CancelSubscriptionWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${(props) => (props.mt ? props.mt : 'unset')};

  ${mediaQ('mobileAll', 'margin-top:5px;')}
`
const IconExclaimation = styled.img`
  width: 25px;
  height: 25px;
  margin-right: 15px;
`

const TextWrapper = styled.div``

const SelectSubscriptionFooter = styled.footer`
  padding: 0 5%;

  ${mediaQ(
    'desktopAll',
    'position: absolute; max-width:40%; margin-left: 0%; bottom: 5%;'
  )}
`
const LinkTo = styled.a`
  color: #212121;
  font-family: 'Open Sans';
  margin-right: 5px;
  font-weight: 600;
  ${fontSizeResponsive(22)}
  ${mediaQ('desktopAll', 'margin-right: 15px')}
`

const LogoutButton = styled.button`
  text-transform: uppercase;
  background-color: #fe0d9f;
  color: white;
  font-family: 'Open Sans';
  font-weight: bold;
  border: none;
  padding: 10px 15px;
  ${fontSizeResponsive(18)}
  margin: 10px;
  position: relative;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: inline-block;
  width: max-content;
  min-width: 165px;
  text-align: center;
  box-sizing: content-box;

  ${mediaQ('desktopAll', 'position: absolute;left: 77vw;top: -35vh;')};
  ${mediaQ('mobileAll', 'position: absolute; right: 2%; top: 1%;')};
`

const ReportErrorButton = styled.button`
  text-transform: uppercase;
  background-color: transparent;
  color: white;
  font-family: 'Open Sans';
  font-weight: bold;
  border: 1px solid #ff0000;
  color: #ff0000;

  padding: 10px 15px;
  ${fontSizeResponsive(18)}
  margin: 10px;
  position: relative;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: inline-block;
  width: max-content;

  ${mediaQ('desktopAll', 'position: absolute;left: 84.8vw;top: -16vh;')};
  ${mediaQ('mobileAll', 'right: -30%')};
`

export const AvailablePaymentMethods = styled.div`
  display: flex;

  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;

  span {
    width: 30%;
  }
`
export const PaymentMethodIcon = styled.div`
  background: ${(props) => (props.src ? `url(${props.src})` : 'unset')};
  background-size: ${(props) => (props.google ? '150%' : 'contain')};
  background-position: ${(props) => (props.przelewy ? '100% 25%' : 'center')};
  background-repeat: no-repeat;
  width: 80px;
  height: 50px;
  margin-left: ${(props) => (props.przelewy ? '15px' : 'none')};

  ${mediaQ('mobileAll', 'width:60px; height: 40px;')};
`

export const SubCheckboxContainer = styled(CheckboxContainer)`
  background-color: rgba(255, 255, 255, 0.8);
  justify-content: flex-start;
  width: fit-content;
  /* padding: 2px 10px 2px 2px; */
  margin-left: ${(props) => (props.isUserReminded ? '0px' : '-8px')};
  border-radius: 5px;
  border: ${(props) => (props.isUserReminded ? '1px solid red' : 'none')};
  transition: ease-in-out 1s all;

  transform: ${(props) =>
    props.isUserReminded && !props.small
      ? 'scale(1.08)'
      : props.isUserReminded && props.small
      ? 'scale(1.01)'
      : 'none'};

  box-shadow: ${(props) =>
    props.isUserReminded
      ? `0 2.8px 2.2px rgba(0, 0, 0, 0.02),
  0 6.7px 5.3px rgba(0, 0, 0, 0.028),
  0 12.5px 10px rgba(0, 0, 0, 0.035),
  0 22.3px 17.9px rgba(0, 0, 0, 0.042),
  0 41.8px 33.4px rgba(0, 0, 0, 0.05),
  0 100px 80px rgba(0, 0, 0, 0.07)`
      : 'unset'};

  div {
    ${fontSizeResponsive(20)}

    a {
      margin: 0 2px;
      color: #fe0d9f;

      &:visited {
        color: #9e0dfe;
      }
    }
  }
`

const TryAppButton = styled.div`
  text-transform: uppercase;
  background-color: rgba(250, 174, 1, 1);
  color: white;
  font-family: 'Open Sans';
  font-weight: bold;
  border: none;
  padding: 10px 15px;
  ${fontSizeResponsive(18)}
  margin: 10px;
  position: relative;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: inline-block;
  width: max-content;
  min-width: 165px;
  text-align: center;
  box-sizing: content-box;
  cursor: pointer;

  ${mediaQ(
    'desktopAll',
    'position: absolute;left: 77vw; right: 5vw;top: -30vh;'
  )};
  ${mediaQ('mobileAll', 'right: -30%')};
`

const Tooltip = styled(ReactTooltip)`
  font-family: 'Open Sans';
  font-weight: 600;
  line-height: 15px;
  max-width: 500px;

  ${mediaQ('mobileAll', 'display: none;')}
`

const PickPaidContentInsteadContainer = styled.div`
  position: absolute;
  top: 8vh;
  width: 60vw;
  left: 20vw;
  text-align: center;
  font-family: 'Asap Condensed';
  font-weight: 500;
  ${fontSizeResponsive(45)};
  padding: 10px;
  color: white;
  background-color: black;

  ${mediaQ('mobileAll', 'width: 90vw; left: 2.5vw; font-size: 25px; top: 7vh;')}

  button {
    padding: 0px;
    background: none;
    font-family: 'Asap Condensed';
    border: none;
    font-weight: bold;
    color: rgba(250, 173, 2, 1);
    ${fontSizeResponsive(45)};
    transition: all 0.3s ease-in-out;

    &:hover {
      color: #fe0d9f;
    }
  }
`

const PaidLessForChallengeContainer = styled.div`
  position: absolute;
  top: 9vh;
  width: 91vw;
  left: 6.8vw;
  font-family: 'Asap Condensed';
  color: black;

  ${mediaQ('mobileAll', 'margin-left: 10px left: 0vw;')}
`

const PaidLessRow = styled.div`
  display: flex;

  align-items: center;
  margin: 5px 0;
  ${fontSizeResponsive(20)};
  font-weight: 500;

  ${mediaQ('mobileAll', 'flex-wrap: wrap; font-size: 13px; margin: 0;')}

  b {
    font-weight: 700;
  }
`

const BiggerText = styled.div`
  font-weight: 800;
  color: #fe0d9f;
  ${fontSizeResponsive(24)};
  margin: 0 5px;
`

const GoToSubPurchaseButton = styled.button`
  display: inline;
  /* padding: 20px; */
  /* background-color: #fe0d9f; */
  background: #9e0dfe;
  color: white;
  border: none;
  font-weight: bold;
  cursor: pointer;
  font-family: 'Asap Condensed';
  border: 1px solid #9e0dfe;
  padding: 10px;
  /* margin: 5px 0px; */
  text-transform: uppercase;
  transition: all 0.3s ease-in-out;
  margin-left: 10px;

  ${mediaQ('mobileAll', 'margin: 0;')}

  &:hover {
    background-color: #9e0dfe;
    border: 1px solid white;
  }
`
const CenterRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 10px 0;
`

const SelectSubscriptionPlanScreen = ({
  // history,
  onSelectSubscription,
  logout,
  isUserClickedButton,
  isUserCheckedLegalRegulationsChheckbox,
  onCheckLegalCheckbox,
  isUserReminded,
  handleTryApp,
  mode,
  subInfo,
  user,
  productCorrectPrice,
  paidContent,
  changeMode,
  userBoughtPackages,
  promoInfo,
  setPromo,
}) => {
  const { promiseInProgress } = usePromiseTracker()
  let history = useHistory()
  const appContext = useContext(AppContext)

  const getPaidContentOtherThanMiazga = (paidProduct) => {
    history.push({
      pathname: `/wybierz-plan/${paidProduct}`,
      mode: paidProduct,
    })
    changeMode(paidProduct)
  }

  const checkIfUserHasPaidContent = () => {
    let hasPackage = false
    const paidContent = ['Szpagat Turecki']

    userBoughtPackages.forEach((userPackage) => {
      if (paidContent.includes(userPackage.product_name)) {
        hasPackage = true
      }
    })

    return hasPackage
  }

  const redirectUserToPromoSubSelect = () => {
    setPromo()
  }

  return (
    <>
      {promoInfo && promoInfo.promo_status == 'PROMO_DIALOG' && (
        <MainScreenPromoBanner className="select-sub">
          <GenericRow>
            <GenericTextSpan
              fSize="1.5rem"
              margin={isMobile ? '0 2% 0 0' : '0 5% 0 0'}
              color="#342152"
            >
              &#x276F; &#x276F; &#x276F;
            </GenericTextSpan>
            <GenericTextSpan
              fSize="1.8rem"
              margin={isMobile ? '0' : '0 5% 0 0'}
              color="#342152"
              fWeight="bold"
              tAlign="center"
            >
              Trwa promocja na MIAZGĘ
            </GenericTextSpan>
            {!isMobile && (
              <GenericButton
                onClick={redirectUserToPromoSubSelect}
                justify="center"
                className="promo-banner-filled-btn"
              >
                SKORZYSTAJ!
              </GenericButton>
            )}
            <GenericTextSpan
              margin={isMobile ? '0 0 0 2%' : '0 0 0 5%'}
              fSize="1.5rem"
              color="#342152"
            >
              &#x276E; &#x276E; &#x276E;
            </GenericTextSpan>
          </GenericRow>
          {isMobile && (
            <GenericRow>
              <GenericButton
                onClick={redirectUserToPromoSubSelect}
                justify="center"
                className="promo-banner-filled-btn"
              >
                SKORZYSTAJ!
              </GenericButton>
            </GenericRow>
          )}
        </MainScreenPromoBanner>
      )}
      <GenericBackgroundLayer
        height={'100vh'}
        className="standard select-subscription-screen"
      >
        <SelectSubBox>
          {isMobile && (
            <GenericIcon
              zIndex={'5'}
              src={MobileSubscriptionImage}
              backgroundSize={'100% 100%'}
              width={'90vw'}
              height={'100vh'}
              position={'absolute'}
              top={'0'}
              left={'0'}
            ></GenericIcon>
          )}

          <GenericColumn
            className="left-col"
            width={isMobile ? '100%' : '50%'}
            justify={'flex-start'}
            align={'flex-end'}
            height={'100%'}
            padding={'3% 1%'}
          >
            {mode === 'sub' && (
              <TwineBallAnnotation
                onClick={() => getPaidContentOtherThanMiazga('Szpagat Turecki')}
              >
                <GenericTextSpan zIndex={'6'} fSize={'1.2rem'}>
                  Chcesz wykupić tylko dostęp do wyzwania szpagat?
                </GenericTextSpan>
                <GenericTextSpan
                  onClick={() =>
                    getPaidContentOtherThanMiazga('Szpagat Turecki')
                  }
                  color={'#a1ff68'}
                  fSize={'1.3rem'}
                  margin={isMobile ? '3% 0 0 0' : '25% 0 0 0'}
                >
                  Sprawdź
                </GenericTextSpan>
              </TwineBallAnnotation>
            )}
            {!isMobile && (
              <GenericIcon
                position={'absolute'}
                top={'4vh'}
                width={'60%'}
                height={'90%'}
                src={FitmatkaImage}
              ></GenericIcon>
            )}
            {!isMobile && (
              <GenericLogo
                theme={appContext.appState.theme == 'light' ? 'light' : null}
                width={'30vw'}
                height={'20vw'}
                zIndex={'2'}
                position={'absolute'}
                bottom={'10vh'}
                right={'0vw'}
              />
            )}
          </GenericColumn>

          <GenericColumn
            className="right-col"
            width={isMobile ? '100%' : '50%'}
            justify="flex-start"
            align="flex-start"
            padding={'3% 1%'}
          >
            <GenericTextSpan
              zIndex={'6'}
              dislay={'block'}
              width={isMobile ? '100%' : '60%'}
              fSize={'2.4rem'}
              margin={'2% 0'}
            >
              Wybierz rodzaj pakietu
            </GenericTextSpan>
            <GenericTextSpan
              zIndex={'6'}
              dislay={'block'}
              width={isMobile ? '100%' : '60%'}
              tAlign={'center'}
              fSize={'1.1rem'}
              opacity={'0.9'}
            >
              Do korzystania z aplikacji i jej zasobów wymagana jest subskrypcja
              lub pakiet
            </GenericTextSpan>

            {mode == 'sub' ? (
              <>
                {' '}
                <SubPlanScreenCard
                  onClick={(e) =>
                    !isUserClickedButton && onSelectSubscription('one', e)
                  }
                >
                  <GenericRow justify="space-between">
                    <PackageButton>Subskrypcja</PackageButton>
                    <GenericTextSpan fSize={'1.8rem'} color={'#a1ff68'}>
                      zł
                    </GenericTextSpan>
                  </GenericRow>
                  <GenericRow justify="space-between">
                    <GenericTextSpan
                      fSize={isMobile ? '1.8rem' : '2.2rem'}
                      fWeight={'bold'}
                    >
                      1 miesiąc
                    </GenericTextSpan>
                    <GenericTextSpan
                      fSize={isMobile ? '2.7rem' : '3.8rem'}
                      color={'#a1ff68'}
                    >
                      69,99
                    </GenericTextSpan>
                  </GenericRow>
                  {promoInfo && promoInfo.promo_status == 'PROMO_DIALOG' && (
                    <GenericRow justify="flex-start" margin={'2% 3% 0 0'}>
                      <GenericIcon
                        margin={'0% 3% 0 0'}
                        src={ExclaimIcon}
                        width={isMobile ? '5.5vw' : '1.5vw'}
                        height={isMobile ? '5.5vw' : '1.5vw'}
                      />
                      <GenericTextSpan fSize={'1.5rem'} fWeight={'bold'}>
                        2 miesiące w cenie jednego!
                      </GenericTextSpan>
                    </GenericRow>
                  )}
                  <GenericRow justify="flex-start" margin={'2% 3% 0 0'}>
                    <GenericIcon
                      margin={'0% 3% 0 0'}
                      src={ExclaimIcon}
                      width={isMobile ? '3.5vw' : '0.8vw'}
                      height={isMobile ? '3.5vw' : '0.8vw'}
                    />
                    <GenericTextSpan>Cykliczna płatność</GenericTextSpan>
                  </GenericRow>

                  <GenericRow justify="flex-start" margin={'2% 3% 0 0'}>
                    <GenericIcon
                      margin={'0% 3% 0 0'}
                      src={ExclaimIcon}
                      width={isMobile ? '3.5vw' : '0.8vw'}
                      height={isMobile ? '3.5vw' : '0.8vw'}
                    />
                    <GenericTextSpan>
                      Zamawiam z obowiązkiem zapłaty
                    </GenericTextSpan>
                  </GenericRow>
                  <GenericRow justify="flex-start" margin={'2% 3% 0 0'}>
                    <GenericIcon
                      margin={'0% 3% 0 0'}
                      src={ExclaimIcon}
                      width={isMobile ? '3.5vw' : '0.8vw'}
                      height={isMobile ? '3.5vw' : '0.8vw'}
                    />
                    <GenericTextSpan>
                      Sybskrypcja nie zawiera wyzwania szpagat
                    </GenericTextSpan>
                  </GenericRow>
                </SubPlanScreenCard>
                {promoInfo && promoInfo.promo_status !== 'PROMO_DIALOG' && (
                  <SubPlanScreenCard
                    onClick={(e) =>
                      !isUserClickedButton && onSelectSubscription('three', e)
                    }
                  >
                    <GenericRow justify="space-between">
                      <PackageButton>Subskrypcja</PackageButton>
                      <GenericTextSpan fSize={'1.8rem'} color={'#a1ff68'}>
                        zł
                      </GenericTextSpan>
                    </GenericRow>
                    <GenericRow justify="space-between">
                      <GenericTextSpan
                        fSize={isMobile ? '1.8rem' : '2.2rem'}
                        fWeight={'bold'}
                      >
                        3 miesiące
                      </GenericTextSpan>
                      <GenericTextSpan
                        fSize={isMobile ? '2.7rem' : '3.8rem'}
                        color={'#a1ff68'}
                      >
                        179,99
                      </GenericTextSpan>
                    </GenericRow>
                    <GenericRow justify="flex-start" margin={'2% 3% 0 0'}>
                      <GenericIcon
                        margin={'0% 3% 0 0'}
                        src={ExclaimIcon}
                        width={isMobile ? '3.5vw' : '0.8vw'}
                        height={isMobile ? '3.5vw' : '0.8vw'}
                      />
                      <GenericTextSpan>Cykliczna płatność</GenericTextSpan>
                    </GenericRow>
                    <GenericRow justify="flex-start" margin={'2% 3% 0 0'}>
                      <GenericIcon
                        margin={'0% 3% 0 0'}
                        src={ExclaimIcon}
                        width={isMobile ? '3.5vw' : '0.8vw'}
                        height={isMobile ? '3.5vw' : '0.8vw'}
                      />
                      <GenericTextSpan>
                        Zamawiam z obowiązkiem zapłaty
                      </GenericTextSpan>
                    </GenericRow>
                    <GenericRow justify="flex-start" margin={'2% 3% 0 0'}>
                      <GenericIcon
                        margin={'0% 3% 0 0'}
                        src={ExclaimIcon}
                        width={isMobile ? '3.5vw' : '0.8vw'}
                        height={isMobile ? '3.5vw' : '0.8vw'}
                      />
                      <GenericTextSpan>
                        Subskrypcja nie zawiera wyzwania szpagat
                      </GenericTextSpan>
                    </GenericRow>
                  </SubPlanScreenCard>
                )}
              </>
            ) : (
              <SubPlanScreenCard
                onClick={(e) =>
                  !isUserClickedButton && onSelectSubscription('turecki', e)
                }
              >
                <GenericRow justify="space-between">
                  <PackageButton>Pakiet</PackageButton>
                  <GenericTextSpan fSize={'1.8rem'} color={'#a1ff68'}>
                    zł
                  </GenericTextSpan>
                </GenericRow>
                <GenericRow justify="space-between">
                  <GenericTextSpan
                    fSize={isMobile ? '1.8rem' : '2.2rem'}
                    fWeight={'bold'}
                  >
                    {mode}
                  </GenericTextSpan>
                  <GenericTextSpan
                    fSize={isMobile ? '2.7rem' : '3.8rem'}
                    color={'#a1ff68'}
                  >
                    44.99
                  </GenericTextSpan>
                </GenericRow>
                <GenericRow justify="flex-start" margin={'2% 3% 0 0'}>
                  <GenericIcon
                    margin={'0% 3% 0 0'}
                    src={ExclaimIcon}
                    width={isMobile ? '3.5vw' : '0.8vw'}
                    height={isMobile ? '3.5vw' : '0.8vw'}
                  />
                  <GenericTextSpan>Jednorazowa płatność</GenericTextSpan>
                </GenericRow>
                <GenericRow justify="flex-start" margin={'2% 3% 0 0'}>
                  <GenericIcon
                    margin={'0% 3% 0 0'}
                    src={ExclaimIcon}
                    width={isMobile ? '3.5vw' : '0.8vw'}
                    height={isMobile ? '3.5vw' : '0.8vw'}
                  />
                  <GenericTextSpan>
                    Zamawiam z obowiązkiem zapłaty
                  </GenericTextSpan>
                </GenericRow>
                <GenericRow justify="flex-start" margin={'2% 3% 0 0'}>
                  <GenericIcon
                    margin={'0% 3% 0 0'}
                    src={ExclaimIcon}
                    width={isMobile ? '3.5vw' : '0.8vw'}
                    height={isMobile ? '3.5vw' : '0.8vw'}
                  />
                  <GenericTextSpan>
                    Dożywotni dostęp do wyzwania szpagat turecki
                  </GenericTextSpan>
                </GenericRow>
              </SubPlanScreenCard>
            )}
            <DemoModeBox zIndex={'2'} onClick={handleTryApp}>
              Wypróbuj aplikację w wersji <b>DEMO</b>
            </DemoModeBox>

            <GenericRow
              zIndex={'8'}
              justify="flex-start"
              width={isMobile ? '94%' : '55%'}
              margin={'2% 3% 0 3%'}
              align={'center'}
            >
              <GenericIcon
                margin={'0% 3% 0 0'}
                src={ExclaimIcon}
                width={isMobile ? '7vw' : '2.2vw'}
                height={isMobile ? '7vw' : '2.2vw'}
              />
              <GenericTextSpan tAlign={'left'}>
                W obu pakietach masz dostęp do wszystkich treningów, oprócz
                wyzwania szpagat{' '}
              </GenericTextSpan>
            </GenericRow>

            <GenericRow
              zIndex={'8'}
              width={isMobile ? '94%' : '55%'}
              margin={'0% 3% 0 1%'}
              justify="flex-start"
            >
              <GenericCheckbox
                regulations
                name={'regulations-checkbox'}
                defaultChecked={false}
                isCheckboxChecked={isUserCheckedLegalRegulationsChheckbox}
                checkCheckbox={(e) => onCheckLegalCheckbox(e)}
                text={``}
                checkboxStyle={{}}
                containerStyle={{
                  margin: '3% 0 0 1.5%',
                  justify: 'flex-start',
                }}
              />
            </GenericRow>

            <GenericRow
              zIndex={'8'}
              justify="flex-start"
              width={isMobile ? '94%' : '55%'}
              margin={'4% 3% 0 3%'}
              align={'center'}
            >
              <GenericTextSpan>Dostępne metody płatności</GenericTextSpan>
              <GenericIcon
                margin={'0% 3% 0 4%'}
                src={VisaIcon}
                width={isMobile ? '10vw' : '2.2vw'}
                height={isMobile ? '10vw' : '2.2vw'}
              />
              <GenericIcon
                margin={'0% 3% 0 2%'}
                src={Mastercardicon}
                width={isMobile ? '10vw' : '2.2vw'}
                height={isMobile ? '10vw' : '2.2vw'}
              />
              <GenericIcon
                margin={'0% 3% 0 2%'}
                src={AmericaExpressIcon}
                width={isMobile ? '10vw' : '2.2vw'}
                height={isMobile ? '10vw' : '2.2vw'}
              />
            </GenericRow>
          </GenericColumn>
        </SelectSubBox>
      </GenericBackgroundLayer>

      {/* <SelectSubscriptionContainer>
      <TopColorBar relative />
      {mode == 'sub' ? (
        <PickPaidContentInsteadContainer>
          Chcesz wykupić tylko dostęp do wyzwania szpagat?{' '}
          <button
            onClick={() => getPaidContentOtherThanMiazga('Szpagat Turecki')}
          >
            Kliknij tutaj
          </button>
        </PickPaidContentInsteadContainer>
      ) : (
        user &&
        !user.has_subscription &&
        !checkIfUserHasPaidContent() && (
          <PaidLessForChallengeContainer>
            <PaidLessRow>
              <SvgElement
                width={isMobile ? ' 12px' : '25px'}
                height={isMobile ? ' 12px' : '25px'}
                fill={'#fe0d9f'}
                src={exclaimation}
                scale={isMobile ? 0.45 : 0.75}
                alt="Wykrzyknik"
              />
              Szpagat z Miazgą = <BiggerText>104,98zł</BiggerText> (szpagat jest
              50% taniej dla użytkowniczek Miazgi)
              <CenterRow>
                <GoToSubPurchaseButton
                  onClick={() => getPaidContentOtherThanMiazga('sub')}
                >
                  wykup subskrypcje miazga
                </GoToSubPurchaseButton>
              </CenterRow>
            </PaidLessRow>

            <PaidLessRow>
              <SvgElement
                width={isMobile ? ' 12px' : '25px'}
                height={isMobile ? ' 12px' : '25px'}
                fill={'#fe0d9f'}
                scale={isMobile ? 0.45 : 0.75}
                src={exclaimation}
                alt="Wykrzyknik"
              />
              Sam szpagat bez Miazgi = <BiggerText>89,99zł</BiggerText>
            </PaidLessRow>

            <PaidLessRow>
              <SvgElement
                width={isMobile ? ' 12px' : '25px'}
                height={isMobile ? ' 12px' : '25px'}
                scale={isMobile ? 0.45 : 0.75}
                fill={'#fe0d9f'}
                src={exclaimation}
                alt="Wykrzyknik"
              />
              Wybór jest prosty, <b> ale należy do Ciebie!</b>
            </PaidLessRow>
          </PaidLessForChallengeContainer>
        )
      )}
      <SelectSubscriptionHeader
        hasSub={user && user.has_subscription}
        paidContentMode={mode == 'sub'}
      >
        <LogoutButton onClick={logout}>Wyloguj się z aplikacji</LogoutButton>
        {/* <ReportErrorButton onClick={logout}>Zgłoś błąd</ReportErrorButton> */}
      {/* {!user.has_subscription && (
          <TryAppButton
            data-tip={
              'Możesz spróbować działania aplikacji bez wykupienia subskrypcji. Pamiętaj jednak, że aplikacja będzie posiadała zablokowane funkcjonalności, które zostaną odblokwoane po zakupieniu subskrypcji lub wymaganego pakietu.'
            }
            data-multiline="true"
            onClick={handleTryApp}
          >
            Spróbuj aplikacji
          </TryAppButton>
        )}
        {mode == 'sub' ? (
          <HeaderText>Wybierz rodzaj pakietu</HeaderText>
        ) : (
          <HeaderText>
            {mode == 'sub' || mode == 'prolong'
              ? `Wykup pakiet`
              : `Wykup dostęp do wyzwania "Szpagat Turecki"`}
          </HeaderText>
        )}
        <TextRow mt={15} fontFamily="Open Sans" textAlign="center">
          <TextBold>
            {mode == 'sub' || mode == 'prolong'
              ? `Do korzystania z aplikacji i jej zasobów wymagana jest subskrypcja
            lub pakiet.`
              : `Do korzystania z materiałów do wyzwania szpagat turecki wymagana jest płatność jednorazowa.`}
          </TextBold>
        </TextRow> */}
      {/* <TextRow
          mt={15}
          fontFamily="Open Sans"
          textAlign="center"
          color="#fe0d9f"
        >
          <TextBold>Masz problem z subskrypcją? Zgłoś błąd.</TextBold>
        </TextRow> */}
      {/* </SelectSubscriptionHeader>

      {mode == 'sub' ? (
        <SelectSubscriptionSection>
          <SelectSubscriptionCard
            onClick={(e) => onSelectSubscription('one', e)}
          >
            <UnskewWrapper>
              <TextRow
                justify="space-between"
                fontFamily="Asap Condensed"
                mb={10}
              >
                <TextColumn color="#c5ff00" fSize={60} uppercase>
                  <TextBold>1 miesiąc</TextBold>
                </TextColumn>
                <TextColumn color="white" fSize={50}>
                  <TextBold>69,99 zł</TextBold>
                </TextColumn>
              </TextRow>

              {subInfo && subInfo.subscription.promo_active && (
                <CancelSubscriptionWrapper mode="card" mt="5px">
                  <SvgElement src={exclaimation} alt="Wykrzyknik" />
                  <TextRow
                    textAlign="left"
                    color="white"
                    fontFamily="Open Sans"
                    fontSize="18"
                  >
                    <TextBold bigger="26px">
                      2 miesiące w cenie jednego!
                    </TextBold>
                  </TextRow>
                </CancelSubscriptionWrapper>
              )}

              <CancelSubscriptionWrapper mode="card" mt={'35px'}>
                <SvgElement src={exclaimation} alt="Wykrzyknik" />
                <TextRow
                  textAlign="left"
                  color="white"
                  fontFamily="Open Sans"
                  fontSize="18"
                >
                  <TextBold>Jednorazowa płatność</TextBold>
                </TextRow>
              </CancelSubscriptionWrapper>

              <CancelSubscriptionWrapper mode="card" mt="5px">
                <SvgElement src={exclaimation} alt="Wykrzyknik" />
                <TextRow
                  textAlign="left"
                  color="white"
                  fontFamily="Open Sans"
                  fontSize="18"
                >
                  <TextBold>Zamawiam z obowiązkiem zapłaty</TextBold>
                </TextRow>
              </CancelSubscriptionWrapper>

              <CancelSubscriptionWrapper mode="card" mt="5px">
                <SvgElement src={exclaimation} alt="Wykrzyknik" />
                <TextRow
                  textAlign="left"
                  color="white"
                  fontFamily="Open Sans"
                  fontSize="18"
                >
                  <TextBold>Pakiet nie zawiera wyzwania szpagat</TextBold>
                </TextRow>
              </CancelSubscriptionWrapper>
            </UnskewWrapper>
          </SelectSubscriptionCard>

          <SelectSubscriptionCard
            onClick={() =>
              !isUserClickedButton && onSelectSubscription('three')
            }
          >
            <UnskewWrapper>
              <TextRow
                justify="space-between"
                fontFamily="Asap Condensed"
                mb={10}
              >
                <TextColumn color="#c5ff00" fSize={60} uppercase>
                  <TextBold>3 miesiące</TextBold>
                </TextColumn>
                <TextColumn color="white" fSize={50}>
                  <TextBold>179,99 zł </TextBold>
                </TextColumn>
              </TextRow>
              <CancelSubscriptionWrapper mode="card" mt="35px">
                <SvgElement src={exclaimation} alt="Wykrzyknik" />
                <TextRow
                  textAlign="left"
                  color="white"
                  fontFamily="Open Sans"
                  fontSize="18"
                >
                  <TextBold>Jednorazowa płatność</TextBold>
                </TextRow>
              </CancelSubscriptionWrapper>
              <CancelSubscriptionWrapper mode="card" mt="5px">
                <SvgElement src={exclaimation} alt="Wykrzyknik" />
                <TextRow
                  textAlign="left"
                  color="white"
                  fontFamily="Open Sans"
                  fontSize="18"
                >
                  <TextBold>Zamawiam z obowiązkiem zapłaty</TextBold>
                </TextRow>
              </CancelSubscriptionWrapper>

              <CancelSubscriptionWrapper mode="card" mt="5px">
                <SvgElement src={exclaimation} alt="Wykrzyknik" />
                <TextRow
                  textAlign="left"
                  color="white"
                  fontFamily="Open Sans"
                  fontSize="18"
                >
                  <TextBold>Pakiet nie zawiera wyzwania szpagat</TextBold>
                </TextRow>
              </CancelSubscriptionWrapper>
            </UnskewWrapper>
          </SelectSubscriptionCard>
        </SelectSubscriptionSection>
      ) : (
        <SelectSubscriptionSection>
          <SelectSubscriptionCard
            onClick={(e) => onSelectSubscription(mode, e)}
          >
            <UnskewWrapper>
              <TextRow
                justify="space-between"
                fontFamily="Asap Condensed"
                mb={10}
              >
                <TextColumn color="#c5ff00" fSize={60} uppercase>
                  <TextBold>{mode}</TextBold>
                </TextColumn>
                <TextColumn color="white" fSize={50}>
                  <TextBold>{productCorrectPrice} zł</TextBold>
                </TextColumn>
              </TextRow>

              <CancelSubscriptionWrapper mode="card" mt={'35px'}>
                <SvgElement src={exclaimation} alt="Wykrzyknik" />
                <TextRow
                  textAlign="left"
                  color="white"
                  fontFamily="Open Sans"
                  fontSize="18"
                >
                  <TextBold>Jednorazowa płatność</TextBold>
                </TextRow>
              </CancelSubscriptionWrapper>

              <CancelSubscriptionWrapper mode="card" mt="5px">
                <SvgElement src={exclaimation} alt="Wykrzyknik" />
                <TextRow
                  textAlign="left"
                  color="white"
                  fontFamily="Open Sans"
                  fontSize="18"
                >
                  <TextBold>Zamawiam z obowiązkiem zapłaty</TextBold>
                </TextRow>
              </CancelSubscriptionWrapper>

              <CancelSubscriptionWrapper mode="card" mt="5px">
                <SvgElement src={exclaimation} alt="Wykrzyknik" />
                <TextRow
                  textAlign="left"
                  color="white"
                  fontFamily="Open Sans"
                  fontSize="18"
                >
                  <TextBold>
                    Dożywotni dostęp do wyzwania szpagat turecki
                  </TextBold>
                </TextRow>
              </CancelSubscriptionWrapper>
            </UnskewWrapper>
          </SelectSubscriptionCard>
        </SelectSubscriptionSection>
      )}

      {mode == 'sub' && (
        <InformationSection>
          <CancelSubscriptionWrapper>
            <IconExclaimation src={exclaimation} alt="Wykrzyknik" />
            <TextRow textAlign="left" fontFamily="Open Sans" fontSize="24">
              <TextBold>
                W obu pakietach masz dostęp do wszystkich treningów, oprócz
                wyzwania szpagat.
              </TextBold>
            </TextRow>
          </CancelSubscriptionWrapper>
        </InformationSection>
      )}
      <SelectSubscriptionFooter>
        <SubCheckboxContainer
          bottom
          mt={20}
          fw={600}
          fs={26}
          isUserReminded={isUserReminded}
        >
          <Checkbox
            className="legalCheckbox"
            checked={isUserCheckedLegalRegulationsChheckbox}
            icon={<CustomUncheckedIcon />}
            checkedIcon={<CustomCheckedIcon />}
            onChange={(event) => onCheckLegalCheckbox(event)}
            value={isUserCheckedLegalRegulationsChheckbox}
          ></Checkbox>
          <div>
            {mode == 'sub'
              ? 'Zapoznałam się i zaakceptowałam'
              : 'Zapoznałem/am się z'}
            <a
              href={
                'https://fitmatkawariatka.pl/polityka-prywatnosci-aplikacja-miazga/'
              }
              target="_blank"
              rel="license"
            >
              {mode == 'sub' ? 'politykę prywatności' : 'polityką prywatności'}
            </a>{' '}
            oraz {mode == 'sub' ? '' : ' zapoznałem/am się i akceptuję'}
            <a
              href={
                mode == 'sub'
                  ? 'https://fitmatkawariatka.pl/regulamin-aplikacji-miazga-nowy/'
                  : 'https://fitmatkawariatka.pl/regulamin-wyzwania-szpagat/'
              }
              target="_blank"
              rel="license"
            >
              {mode == 'sub' ? 'regulamin' : ' regulamin WYZWANIA „SZPAGAT”'}
            </a>
          </div>
        </SubCheckboxContainer>

        <AvailablePaymentMethods>
          <TextColumn fw={'bold'} fSize={20} fontFamily="Open Sans">
            Dostępne metody płatności:
          </TextColumn>
          <PaymentMethodIcon src={visaIcon}></PaymentMethodIcon>
          <PaymentMethodIcon src={masterCardIcon}></PaymentMethodIcon>
          <PaymentMethodIcon src={americanExpressIcon}></PaymentMethodIcon>
          <PaymentMethodIcon google src={googlePayIcon}></PaymentMethodIcon>
          <PaymentMethodIcon src={przelewy24Icon} przelewy></PaymentMethodIcon>
        </AvailablePaymentMethods>
      </SelectSubscriptionFooter>
      <Tooltip className="tooltip" type="info" />
      {promiseInProgress && <Loader />}
    </SelectSubscriptionContainer> */}
    </>
  )
}

export default SelectSubscriptionPlanScreen
